import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
 
import axios from "../../../utils/axios";
import {
    CALL_PPOR_API,
    MIDDLE_WARE_BASE_URL_v1,
} from "../../../utils/CONSTANTS";
 
const initialState = {
    getnewfeatureannouncementState: '',
    getnewfeatureannouncementData: '',
};
export const getnewfeatureannouncement : any = createAsyncThunk(
    "get/getnewfeatureannouncement",
    async (data: any) => {
        const response = axios.postStringRequest(
            MIDDLE_WARE_BASE_URL_v1() + CALL_PPOR_API(),
            data
        );
        return response;
    }
);
 
 
const getnewfeatureannouncementSlice = createSlice({
    name: "getnewfeatureannouncement",
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(getnewfeatureannouncement.pending, (state) => {
                state.getnewfeatureannouncementState = "pending";
            })
            .addCase(getnewfeatureannouncement.fulfilled, (state, action) => {
                let tempRes = action.payload.data?.response;
                if (typeof tempRes === "string") {
                    tempRes = JSON.parse(tempRes);
                    // console.log(tempRes + "tempRes");
                }
                state.getnewfeatureannouncementState = "fulfilled";
                state.getnewfeatureannouncementData = tempRes?.response?.newfeature;
                console.log("getnewfeatureannouncementData", state.getnewfeatureannouncementData);
            })
            .addCase(getnewfeatureannouncement.rejected, (state) => {
                state.getnewfeatureannouncementState = "failed";
            })
});
 
export const getnewfeatureannouncements = (state: any) => state.getnewfeatureannouncement;
 
export default getnewfeatureannouncementSlice.reducer;
 
 